import React, { useCallback, useMemo } from 'react';

import { getBezierPath, EdgeLabelRenderer, BaseEdge, useNodes } from '@xyflow/react';
import { useRecoilState } from 'recoil';

import { addNodeMenuState } from '../atoms/add-node-menu-atom';

import { StyledEdge } from './styles';

import type { BaseNodeData, NodeType } from '../models';
import type { EdgeProps } from '@xyflow/react';

export function NoEdge({ id, source, ...props }: EdgeProps) {
  const [edgePath, labelX, labelY] = getBezierPath(props);

  const [, setAddNodeMenuState] = useRecoilState(addNodeMenuState);
  const nodes = useNodes();
  const sourceNode = useMemo(() => nodes.find((node) => node.id === source), [nodes, source]);
  const nodeData = sourceNode?.data as BaseNodeData;

  const addNoNode = useCallback(
    (nodeType: NodeType) => {
      nodeData?.onAddNode?.(source, nodeType, 'no');
    },
    [nodeData, source]
  );

  const handleOpenAddNodeMenu = useCallback(
    (e: React.MouseEvent<HTMLDivElement>) => {
      e.stopPropagation();
      setAddNodeMenuState({ anchorEl: e.currentTarget, isOpen: true, onAdd: addNoNode, conditionalAllowed: false });
    },
    [addNoNode, setAddNodeMenuState]
  );

  return (
    <>
      <BaseEdge id={id} path={edgePath} />
      <EdgeLabelRenderer>
        <StyledEdge labelX={labelX} labelY={labelY} onClick={handleOpenAddNodeMenu}>
          No
        </StyledEdge>
      </EdgeLabelRenderer>
    </>
  );
}
